import React from "react";

import { Row, Col,Modal } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/OurServices/OurServices.css";

function info(valExample) {
     Modal.info({
         
         content: (
             <div>
                 <p>
                     {valExample}
                 </p>
             </div>
         ),
         onOk() { },
         okText:"بستن",
     });
 }

const TextTabs = props => {
     return props.size === "laptopdesktop" ? (
          <div>
               <Row>
                    <Col span={24}>
                         <Center>
                              <Margin top={4}>
                                   <div>
                                        <p className="cardTitle"><strong>{props.title}</strong></p>
                                   </div>
                              </Margin>
                         </Center>
                         <Center>
                              <hr className="cardTitleHR" />
                         </Center>
                         <Margin top={2}></Margin>
                         <div style={{ paddingRight: "50px", paddingLeft: '50px' }}>
                              <p className="textParagraph">
                                    {props.text}
                              </p>
                              
                                   <p onClick={() => info(props.exampleVal)}  className="textParagraph" style={{cursor:"pointer"}}>{props.example}</p>
                             
                              <p className="textParagraph">
                                    {props.textTwo}
                              </p>
                         </div>
                    </Col>
               </Row>
          </div>

     ) : props.size === "tablet" ? (
          <div style={{backgroundColor:"#fff" , opacity:"95%" , borderRadius:"20px"}}>
               <Row>
                    <Col span={24}>
                         <Center>
                              <Margin top={4}>
                                   <div>
                                        <p className="cardTitleTablet"><strong>{props.title}</strong></p>
                                   </div>
                              </Margin>
                         </Center>
                         <Center>
                              <hr className="cardTitleHRTablet" />
                         </Center>
                         <Margin top={2}></Margin>
                         <div style={{ paddingRight: "25px", paddingLeft: '25px' }}>
                         <p className="textParagraphTablet">
                                    {props.text}
                              </p>
                              
                                   <p onClick={() => info(props.exampleVal)}  className="textParagraphTablet" style={{cursor:"pointer"}}>{props.example}</p>
                             
                              <p className="textParagraphTablet">
                                    {props.textTwo}
                              </p>
                         </div>
                    </Col>
               </Row>
               <Margin bottom={4}></Margin>
          </div>

     ) : (
                    <div style={{backgroundColor:"#fff" , opacity:"95%" , borderRadius:"20px"}}>
                         <Row>
                    <Col span={24}>
                         <Center>
                              <Margin top={4}>
                                   <div>
                                        <p className="cardTitleMobile"><strong>{props.title}</strong></p>
                                   </div>
                              </Margin>
                         </Center>
                         <Center>
                            <hr style={{
                                             border: ".11em solid #e13024",
                                             width: "30%",
                                             marginTop: "-10px",
                            }} />
                        </Center>
                         <Margin top={2}></Margin>
                         <div style={{ paddingRight: "10px", paddingLeft: '10px' }}>
                         <p className="textParagraphMobile">
                                    {props.text}
                              </p>
                              
                                   <p onClick={() => info(props.exampleVal)}  className="textParagraphMobile" style={{cursor:"pointer"}}>{props.example}</p>
                             
                              <p className="textParagraphMobile">
                                    {props.textTwo}
                              </p>
                         </div>
                    </Col>
               </Row>
               <Margin bottom={4}></Margin>
                    </div>
               );
};

export default TextTabs;
